import { Action } from '@ngrx/store';

import { FeatureInterface } from '../../models';
import { FeatureControlActionType } from './feature-control-action-type.enum';

export class LoadFeatures implements Action {
  public readonly type: FeatureControlActionType =
    FeatureControlActionType.LoadFeatures;

  constructor(public readonly payload: any = undefined) {}
}

export class LoadFeaturesCompleted implements Action {
  public readonly type: FeatureControlActionType =
    FeatureControlActionType.LoadFeaturesCompleted;

  constructor(public readonly payload: FeatureInterface[]) {}
}

export class LoadFeaturesFailed implements Action {
  public readonly type: FeatureControlActionType =
    FeatureControlActionType.LoadFeaturesFailed;

  constructor(public readonly payload: string) {}
}

export type FeatureControlActions =
  | LoadFeatures
  | LoadFeaturesCompleted
  | LoadFeaturesFailed;
